// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_stat3_label = /** @type {(inputs: {}) => string} */ () => {
	return `Swiss engineered`
};

const el_tech_stat3_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ελβετική μηχανική`
};

const ru_tech_stat3_label = /** @type {(inputs: {}) => string} */ () => {
	return `швейцарская разработка`
};

const he_tech_stat3_label = /** @type {(inputs: {}) => string} */ () => {
	return `פיתוח שוויצרי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_stat3_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_stat3_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_stat3_label", locale)
	if (locale === "en") return en_tech_stat3_label(inputs)
	if (locale === "el") return el_tech_stat3_label(inputs)
	if (locale === "ru") return ru_tech_stat3_label(inputs)
	if (locale === "he") return he_tech_stat3_label(inputs)
	return "tech_stat3_label"
};